module.exports = __webpack_public_path__ + "img/imperial.fd145b6b.png";